/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-13 18:34:28
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToComplexTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { getVisual } from '../../../controller';
import { drop, slice } from 'lodash';

const defaultValue = `
传统媒体类	中央级媒体	0
传统媒体类	泛财经媒体	0
传统媒体类	行业媒体	3
传统媒体类	大众媒体	44
网络媒体类	中央级网媒	9
网络媒体类	泛财经网媒	31
网络媒体类	行业网媒	303
网络媒体类	大众网媒	360
自媒体类	泛财经类自媒体	0
自媒体类	行业类自媒体	3
自媒体类	大众类自媒体	5604
`

const defaultColorValue = `
柱状图颜色	#009599
`

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: defaultValue,
      colorValue: defaultColorValue,
      dataset: [],
      tableColumns: [],
      tableList: [],

      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  // componentDidMount () {
  //   const { onChange } = this.props;
  //   const result = {
  //     ...Form.parse(defaultValue),
  //   };

  //   this.setState(result);
  //   typeof onChange === 'function' && onChange(result);
  // }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('12').then(value => {
      const _table = Form.parse(value);
      const _color = Form.parseColor(defaultColorValue);


      this.setState({
        value: value,
        ..._table,
        ..._color,
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._color,
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    const source = drop(dataset, 1);
    const tableSource = source.map(item => [item[0], item[1], item[2]])
    const chartSource = source.map(item => [item[0], item[1], item[3]])
    const { columns, list } = parseArrayToComplexTable(tableSource);

    return {
      dataset,
      tableColumns: [
        {
          dataIndex: 'customKey',
          title: '类型',
          style: { width: 100 },
        },
        ...columns
      ],
      tableList: list.map(item => ({ customKey: '条数', ...item })),
      ...Form.parseChart(chartSource),
    }
  }
 
  static parseChart = (dataset = []) => {
    const { axis: chartTitle, list: chartList } = dataset
      .map(item => item.slice(1))
      .reduce((acc, [name, value]) => {
        acc.axis.push(name);
        acc.list.push(value);
        return acc;
      }, { axis: [], list: [] }) 
    
    return { chartTitle, chartList }
  }

  static parseColor = (str) => {
    const dataset = parseStringToArray(str);
    
    return { chartColorList: dataset.map(item => item[1]) }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const colorValue = e.target.value;
    const _color = Form.parseColor(colorValue);

    this.setState({
      colorValue,
      ..._color,
    });

    typeof onChange === 'function' && onChange(_color);
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P12/Form.js